import css from './MapMarker.module.scss'

export default function MapMarker({ label, index, action }) {
	return (
		<div className={css['container']} onClick={action}>
			<i className={`fa fa-map-marker-alt ${css['marker']}`} />
			<p className={css['label']}>
				{label}
			</p>
		</div>
	)
}
